import { Avatar, FloatButton } from "antd";
import { useEffect, useState } from "react";
import { useChat } from "src/contexts/chat.context";
import styled, { keyframes } from "styled-components";
import SparkleIcon from "../../assets/images/ai-agent-icon.svg";
import ExpandedSparkleIcon from "../../assets/images/expanded-ai-agent-icon.svg";
import { ChatOption } from "./enums";

const pulse = keyframes`
  0%   { transform: scale(1); }
  50%  { transform: scale(1.15); }
  100% { transform: scale(1); }
`;

const ResponsiveFloatButton = styled(FloatButton)<{ $expanded: boolean }>`
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: ${({ $expanded }) => ($expanded ? "200px" : "48px")};
  height: 48px;
  border-radius: 24px;
  padding: 0;
  transition: all 0.5s ease;

  /* sombra arredondada */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  &.ant-float-btn-primary {
    background: linear-gradient(to right, #66c790, #884ea6) !important;
  }

  &.ant-float-btn-primary .ant-float-btn-body {
    background: linear-gradient(to right, #66c790, #884ea6) !important;
    transition: background 0.2s;
  }

  .ant-float-btn-body .ant-float-btn-content {
    /*define espaço do conteúdo do botão*/
    padding: ${({ $expanded }) => ($expanded ? "32px 110px" : "32px 40px")};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s ease;
  }

  animation: ${pulse} 1s infinite ease-in-out;

  /* ao passar o mouse, remove a animação */
  &:hover {
    animation: none;
  }

  @media (max-width: 600px) {
    width: ${({ $expanded }) => ($expanded ? "160px" : "28px")};
    height: 28px;
    right: 12px;
    bottom: 12px;
  }
`;

const FullAvatar = styled(Avatar)<{ $expanded: boolean }>`
  width: ${({ $expanded }) => ($expanded ? "1320%" : "510%")};
  height: 140%;
  right: ${({ $expanded }) => ($expanded ? "118px" : "40px")};
`;

export default function AiAgentFloatButton() {
  const { setOption } = useChat();
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExpanded(false);
    }, 1500);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleClick = () => {
    setOption(ChatOption.CHAT);
    localStorage.setItem("ai_chat_option", ChatOption.CHAT.toString());
    localStorage.setItem("show_ai_chat", "1");
  };

  return (
    <ResponsiveFloatButton
      $expanded={isExpanded}
      onClick={handleClick}
      onMouseEnter={() => {
        setIsExpanded(true);
      }}
      onMouseLeave={() => {
        setIsExpanded(false);
      }}
      type="primary"
      icon={
        <>
          <FullAvatar
            $expanded={isExpanded}
            src={isExpanded ? ExpandedSparkleIcon : SparkleIcon}
          />
        </>
      }
    />
  );
}
